// Components/sidebars/RightContentColumn.jsx
import { useNavigate } from "react-router-dom";
import { useDispatch } from "react-redux";
import { hide, setActiveIndex } from "../../redux/SideBarSlice";
import "./Rightcont.scss";
import ChevronRightRoundedIcon from "@mui/icons-material/ChevronRightRounded";


const RightContentColumn = ({ cards, limit }) => {
  const navigate = useNavigate();
  const dispatch = useDispatch();

  const handleNavigation = (path) => {
    navigate(path);
    dispatch(hide());
    dispatch(setActiveIndex(null));
  };

  // let displayedCards = cards && cards.length > 0 ? cards : DEFAULT_CARDS;

  // If limit is specified, slice the cards to that limit
  // if (limit && displayedCards.length > limit) {
  //   displayedCards = displayedCards.slice(0, limit);
  // }

  const isLimited = cards.length === 4;

  return (
    <div className={`right-content ${isLimited ? "limit-4" : ""}`}>
      <div className="section">
        {cards.map((card, index) => (
          <div
            className="card"
            key={index}
            onClick={() => handleNavigation(card.path)}
          >
            <div className="card_imgg">
               <img  loading="lazy" src={card.img} alt={card.alt} />
            </div>
            <div className="card-body">
              <p className="card-title">{card.title}</p>
              <span className="read-more">
                Read more <ChevronRightRoundedIcon className="icon" />
              </span>
            </div>
          </div>
        ))}
      </div>
    </div>
  );
};

export default RightContentColumn;
